var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#0B0E11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9871 22.1185L25 15.1057L32.0164 22.1222L36.0969 18.0414L25 6.94434L13.9065 18.0378L17.9871 22.1185ZM11.0251 20.919L15.1056 24.9995L11.0249 29.0803L6.94434 24.9998L11.0251 20.919ZM17.9871 27.8813L25 34.8938L32.0163 27.8777L36.0991 31.9563L36.0969 31.9583L25 43.0554L13.9064 31.962L13.9007 31.9564L17.9871 27.8813ZM43.0558 25.0003L38.9753 29.0808L34.8948 25.0003L38.9753 20.9197L43.0558 25.0003Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceWalletIcon);
export default __webpack_public_path__ + "static/media/binanceWalletIcon.2d32b260a96f8dc1965221bfcea8e558.svg";
export { ForwardRef as ReactComponent };